import { Component } from '@angular/core';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { ButtonSize, ButtonStyle } from '../../../../shared/enums/button.enum';
import { OptionSwitcherComponent } from '../../../../shared/components/controllers/option-switcher/option-switcher.component';
import { SearchComponent } from '../../../../shared/components/controllers/search/search.component';
import {
  FormControl,
  FormGroup,
  FormsModule,
  Validators
} from '@angular/forms';
import { JsonPipe } from '@angular/common';
import { RadioComponent } from '../../../../shared/components/controllers/radio/radio.component';
import { CounterComponent } from '../../../../shared/components/controllers/counter/counter.component';
import { Dialog, DialogModule } from '@angular/cdk/dialog';
import { DialogWrapperComponent } from '../../../../shared/components/wrappers/dialog-wrapper/dialog-wrapper.component';
import { TextareaComponent } from '../../../../shared/components/controllers/textarea/textarea.component';
import { InputComponent } from '../../../../shared/components/controllers/input/input.component';
import { TimePickerComponent } from '../../../../shared/components/controllers/time-picker/time-picker.component';
import { DatePickerComponent } from '../../../../shared/components/controllers/date-picker/date-picker.component';
import { RadioCardComponent } from '../../../../shared/components/controllers/radio-card/radio-card.component';
import { InputAddressComponent } from '../../../../shared/components/controllers/input-address/input-address.component';
import { DynamicValidationDependencies } from '../../../../shared/components/controllers/control-error/validation-error-messages.token';

@Component({
  selector: 'app-ui-toolkit-page',
  templateUrl: './ui-toolkit-page.component.html',
  imports: [
    ButtonComponent,
    OptionSwitcherComponent,
    SearchComponent,
    FormsModule,
    JsonPipe,
    RadioComponent,
    CounterComponent,
    DialogModule,
    TextareaComponent,
    InputComponent,
    TimePickerComponent,
    DatePickerComponent,
    RadioCardComponent,
    InputAddressComponent,
    ...DynamicValidationDependencies
  ],
  styleUrl: './ui-toolkit-page.component.scss'
})
export class UiToolkitPageComponent {
  optionSwitcher: string = '';
  search: string = '';
  counter: number = 0;
  textarea: string = '';
  checkbox: string[] = [];
  input: FormControl = new FormControl('', [Validators.required]);
  radioForm = new FormGroup({
    value: new FormControl(null)
  });

  radioCardControl: string = '';
  addressControl: string = '';

  protected readonly ButtonSize = ButtonSize;
  protected readonly ButtonStyle = ButtonStyle;
  protected readonly cardSubitems = [
    {
      value: 'meet_door',
      label: 'Meet at my door'
    },
    {
      value: 'meet_outside',
      label: 'Meet Outside'
    },
    {
      value: 'meet_lobby',
      label: 'Meet In the Lobby'
    }
  ];

  constructor(private dialog: Dialog) {}

  onInputBlur() {
    console.log('onInputBlur');
  }

  openTestDialog() {
    this.dialog.open(DialogWrapperComponent, {
      data: { title: 'Test Dialog 2' },
      width: '400px'
    });
  }
}
